import {
  getElementLeft,
  getElementTop,
  getScrollTop,
  canvasResize
} from './Tools/utils'
import Brush from './Tools/Brush.js'
import { debounce } from '../../../../common/js/common'

class DrawingBoard {
  constructor({
    sendDrawingDelta,
    isHost = false,
    el,
    height = 400,
    toolBtnSize = 50,
    saveBtn = false,
    toolList = ['Brush'],
    maxRecall = 5
  }) {
    // 定义tool按钮大小
    this.toolBtnSize = toolBtnSize
    // 设备像素px比
    this.dpr = window.devicePixelRatio
    // 最大撤回次数
    this.maxRecall = maxRecall
    // 是否显示保存按钮
    this.saveBtn = saveBtn
    // isHost
    this.isHost = isHost
    // sync
    this.sendDrawingDelta = debounce(sendDrawingDelta, 50)

    if (typeof el === 'string') {
      try {
        this.containerEl = document.querySelector(el)
      } catch (error) {
        throw new Error('传入el错误')
      }
    } else {
      if (el.childNodes) {
        this.containerEl = el
      } else {
        throw new Error('传入的不是dom节点')
      }
    }

    // [工具按钮div]
    // 用于放置各组件按钮
    this.btnContainerEl = this.containerEl.querySelector('.btn-container')

    // [工具选项div]
    // 用于放置各组件对应的选项组合
    this.optionContainerEl = this.containerEl.querySelector('.option-container')

    // [前置canvas]
    // 用于绘制交互层 对所有工具暴露 默认是display none状态
    this.frontCanvasEl = this.containerEl.querySelector('.front-canvas')
    this.frontCanvasEl.height = height * this.dpr // 高清适配
    this.frontCanvasCtx = this.frontCanvasEl.getContext('2d')

    // [主体canvas]
    // 用于绘制图形 撤销功能在这一层 对所有工具暴露
    this.mainCanvasEl = this.containerEl.querySelector('.main-canvas')
    this.mainCanvasEl.height = height * this.dpr
    this.mainCanvasCtx = this.mainCanvasEl.getContext('2d')

    // [canvas容器]
    this.canvasContainerEl = this.containerEl.querySelector('.canvas-container')
    this.canvasContainerEl.style.height = height + 'px'

    // [回退canvas]
    // 用于保存maxRecall次数限制之前的绘制层  是撤回功能的主要实现
    this.recallCanvasEl = document.createElement('canvas')
    this.recallCanvasEl.height = height * this.dpr
    this.recallCanvasCtx = this.recallCanvasEl.getContext('2d')

    // 绘制事件队列
    // 工具绘制函数序列 最大长度受 maxRecall限制
    this.renderList = []

    // 被撤销的绘制队列
    this.recallBackList = []

    // 当前的工具组件实例
    // canvas触发事件时会调用实例中的指定函数
    this.currentTool = null

    // resize延迟调用 防止频繁触发resize
    this.resizeTimer = null

    // event 数据
    this.eventState = []

    // 执行初始化函数 注册 toolList中的工具
    this.init(toolList)
  }
  // 初始化
  init(toolList) {
    if (!toolList || !toolList.length) {
      throw new Error('传入tools错误')
    }

    try {
      this.registerTool(Brush)
    } catch (error) {
      console.log(error)
      throw new Error(`注册组件出错`)
    }

    // // 逐个注册组件
    // toolList.forEach((toolName) => {
    //   try {
    //     import(`./Tools/${toolName}.js`)
    //       .then(module => {
    //         this.registerTool(module.default);
    //       })
    //   } catch (error) {
    //     console.log(error);
    //     throw new Error(`注册组件${toolName}出错`);
    //   }
    // })

    // 执行事件绑定init
    this.eventListenerInit()

    // 初始化canvas尺寸
    this.frontCanvasEl.width = this.canvasContainerEl.clientWidth * this.dpr
    this.frontCanvasEl.style.width = this.canvasContainerEl.clientWidth + 'px'

    this.mainCanvasEl.width = this.canvasContainerEl.clientWidth * this.dpr
    this.mainCanvasEl.style.width = this.canvasContainerEl.clientWidth + 'px'

    this.recallCanvasEl.width = this.canvasContainerEl.clientWidth * this.dpr

    // 监听窗口resize
    window.addEventListener('resize', this.resize.bind(this))
  }
  // - 注册工具
  toolRegister(Tool) {
    // 注册tool组件 传入一个组件的构造函数
    // 向组件构造函数暴露 frontCanvasCtx/mainCanvasCtx
    const tool = new Tool({
      frontCanvasEl: this.frontCanvasEl,
      frontCanvasCtx: this.frontCanvasCtx,
      mainCanvasEl: this.mainCanvasEl,
      mainCanvasCtx: this.mainCanvasCtx,
      isHost: this.isHost
    })

    // 根据配置参数设置按钮尺寸
    tool.btnEl.style.width = this.toolBtnSize + 'px'
    tool.btnEl.style.height = this.toolBtnSize + 'px'

    // 监听组件的工具按钮点击事件 触发toolChange
    tool.btnEl.addEventListener('click', () => {
      this.toolChange(tool)
    })

    // 将组件的工具按钮节点插入工具按钮容器
    this.btnContainerEl.appendChild(tool.btnEl)
    // 将工具配置选项节点插入工具选项div容器
    this.optionContainerEl.appendChild(tool.optionEl)

    if (this.currentTool === null) {
      // 如果当前生效tool为空则使用第一个注册的tool
      // 避免构建后无默认选中的tool
      this.toolChange(tool)
    }
  }
  registerTool(Tool) {
    this.toolRegister(Tool)
  }
  handleStart(e) {
    // 阻止默认事件  用于防止touch事件之后触发mouse事件
    e.preventDefault && e.preventDefault()
    this.canvasContainerElPosition.pageX = getElementLeft(
      this.canvasContainerEl
    )
    this.canvasContainerElPosition.pageY = getElementTop(this.canvasContainerEl)
    // 实时获取滚动偏移
    const scrollY = getScrollTop()
    let pageX
    let pageY
    if (e.type === 'touchstart') {
      pageX = e.touches[0].pageX
      pageY = e.touches[0].pageY - scrollY
    } else {
      pageX = e.pageX
      pageY = e.pageY
    }
    const canvasX = pageX - this.canvasContainerElPosition.pageX
    const canvasY = pageY - this.canvasContainerElPosition.pageY
    // 封装事件触发的容器中坐标
    e.canvasX = canvasX * this.dpr
    e.canvasY = canvasY * this.dpr
    // 落笔绘制
    this.currentTool.drawStartFn &&
      this.currentTool.drawStartFn.call(this.currentTool, e)
  }
  handleMove(e) {
    const scrollY = getScrollTop()
    let pageX
    let pageY
    if (e.type === 'touchmove') {
      pageX = e.touches[0].pageX
      pageY = e.touches[0].pageY - scrollY
    } else {
      pageX = e.pageX
      pageY = e.pageY
    }
    const canvasX = pageX - this.canvasContainerElPosition.pageX
    const canvasY = pageY - this.canvasContainerElPosition.pageY
    // 封装事件触发的容器中坐标
    e.canvasX = canvasX * this.dpr
    e.canvasY = canvasY * this.dpr
    // 移动绘制
    this.currentTool.drawMoveFn &&
      this.currentTool.drawMoveFn.call(this.currentTool, e)
  }
  handleEnd(e) {
    // 清空缓存
    this.canvasContainerElPosition.pageX = null
    this.canvasContainerElPosition.pageY = null
    // 抬笔绘制
    if (this.currentTool.drawEndFn) {
      // 返回一个 ctx渲染函数
      const renderFn = this.currentTool.drawEndFn.call(this.currentTool, e)
      if (renderFn) {
        // 返回了渲染函数
        this.render(renderFn)
      }
    }
  }
  syncStart(e) {
    if (!this.isHost) return
    this.handleStart(e)
    const { dpr } = this
    const syncEvent = {
      s: `${(e.canvasX / dpr).toFixed(3)},${(e.canvasY / dpr).toFixed(3)}`
    }
    this.eventState = []
    this.eventState.push(syncEvent)
    this.sendDrawingDelta({
      boardData: {
        event: this.eventState
      }
    })
  }
  syncMove(e) {
    if (!this.isHost) return
    this.handleMove(e)
    const { dpr } = this
    const syncEvent = {
      m: `${(e.canvasX / dpr).toFixed(3)},${(e.canvasY / dpr).toFixed(3)}`
    }
    this.eventState.push(syncEvent)
    this.sendDrawingDelta({
      boardData: {
        event: this.eventState
      }
    })
  }
  syncEnd(e) {
    if (!this.isHost) return
    this.handleEnd(e)
    const syncEvent = { e: 0 }
    this.eventState.push(syncEvent)
    this.sendDrawingDelta({
      boardData: {
        event: this.eventState
      }
    })
  }
  // - 事件监听初始化
  eventListenerInit() {
    this.canvasContainerElPosition = {
      // touchstart mousedown时缓存容器坐标 避免重复计算
      pageX: null,
      pageY: null
    }

    const startFn = e => {
      // 阻止默认事件  用于防止touch事件之后触发mouse事件
      e.preventDefault && e.preventDefault()
      // 缓存容器坐标
      canvasContainerElPosition.pageX = getElementLeft(this.canvasContainerEl)
      canvasContainerElPosition.pageY = getElementTop(this.canvasContainerEl)
      // 实时获取滚动偏移
      const scrollY = getScrollTop()
      let pageX
      let pageY
      if (e.type === 'touchstart') {
        pageX = e.touches[0].pageX
        pageY = e.touches[0].pageY - scrollY
      } else {
        pageX = e.pageX
        pageY = e.pageY
      }
      const canvasX = pageX - canvasContainerElPosition.pageX
      const canvasY = pageY - canvasContainerElPosition.pageY
      // 封装事件触发的容器中坐标
      e.canvasX = canvasX * this.dpr
      e.canvasY = canvasY * this.dpr
      // 落笔绘制
      this.currentTool.drawStartFn &&
        this.currentTool.drawStartFn.call(this.currentTool, e)
      if (!this.isHost) return
      const syncEvent = { s: `${canvasX},${canvasY}` }
      this.eventState.push(syncEvent)
      this.sendDrawingDelta({
        boardData: {
          event: this.eventState
        }
      })
    }
    const moveFn = e => {
      const scrollY = getScrollTop()
      let pageX
      let pageY
      if (e.type === 'touchmove') {
        pageX = e.touches[0].pageX
        pageY = e.touches[0].pageY - scrollY
      } else {
        pageX = e.pageX
        pageY = e.pageY
      }
      const canvasX = pageX - canvasContainerElPosition.pageX
      const canvasY = pageY - canvasContainerElPosition.pageY
      // 封装事件触发的容器中坐标
      e.canvasX = canvasX * this.dpr
      e.canvasY = canvasY * this.dpr
      // 移动绘制
      this.currentTool.drawMoveFn &&
        this.currentTool.drawMoveFn.call(this.currentTool, e)
      if (!this.isHost) return
      const syncEvent = { m: `${canvasX},${canvasY}` }
      this.eventState.push(syncEvent)
      this.sendDrawingDelta({
        boardData: {
          event: this.eventState
        }
      })
    }
    const endFn = e => {
      // 清空缓存
      canvasContainerElPosition.pageX = null
      canvasContainerElPosition.pageY = null
      // 抬笔绘制
      if (this.currentTool.drawEndFn) {
        // 返回一个 ctx渲染函数
        const renderFn = this.currentTool.drawEndFn.call(this.currentTool, e)

        if (renderFn) {
          // 返回了渲染函数
          this.render(renderFn)
          if (!this.isHost) return
          const syncEvent = { e: 0 }
          this.eventState.push(syncEvent)
          this.sendDrawingDelta({
            boardData: {
              event: this.eventState
            }
          })
        }
      }
    }

    // 监听canvas事件 并触发相应函数
    // frontCanvas z-index在 mainCanvas之上
    // tool.frontCanvasShow=true时 mainCanvas事件将无法触发
    this.frontCanvasEl.addEventListener('touchstart', this.syncStart.bind(this))
    this.frontCanvasEl.addEventListener('touchmove', this.syncMove.bind(this))
    this.frontCanvasEl.addEventListener('touchend', this.syncEnd.bind(this))

    // 统一鼠标事件触发等同于触摸事件
    this.frontCanvasEl.addEventListener('mousedown', e => {
      startFn(e)
      document.body.addEventListener('mousemove', moveFn)
      document.body.addEventListener('mouseup', function mouseupFn(event) {
        endFn(event)
        // 移除监听
        document.body.removeEventListener('mousemove', moveFn)
        document.body.removeEventListener('mouseup', mouseupFn)
      })
    })

    // 触发 mousemove事件后调用工具的 mousemoveFn
    this.frontCanvasEl.addEventListener('mousemove', e => {
      e.canvasX = (e.pageX - getElementLeft(this.canvasContainerEl)) * this.dpr
      e.canvasY = (e.pageY - getElementTop(this.canvasContainerEl)) * this.dpr
      this.currentTool.mousemoveFn &&
        this.currentTool.mousemoveFn.call(this.currentTool, e)
    })

    // 撤销按钮绑定事件
    this.containerEl
      .querySelector('.recall')
      .addEventListener('click', this.recall.bind(this))
    // 反撤销按钮
    this.containerEl
      .querySelector('.recall-back')
      .addEventListener('click', this.recallBack.bind(this))
    // 保存按钮
    if (this.saveBtn) {
      const saveBtnEl = this.containerEl.querySelector('.save')
      saveBtnEl.style.display = 'inline-block'
      saveBtnEl.addEventListener('click', this.save.bind(this, 'btn'))
    }
  }
  // 变更当前的tool 传入的是一个tool实例
  toolChange(tool) {
    // 切换工具时清空 frontCanvas
    this.frontCanvasCtx.clearRect(
      0,
      0,
      this.frontCanvasEl.width,
      this.frontCanvasEl.height
    )
    // 判断当前 tool 移除响应样式
    if (this.currentTool) {
      this.currentTool.optionEl.classList.remove('active')
      this.currentTool.btnEl.classList.remove('active')
    }
    // 为将切换的工具提供 active样式
    tool.btnEl.classList.add('active')
    tool.optionEl.classList.add('active')

    // 切换工具
    this.currentTool = tool
    // 是否存在 mousemove函数 有则隐藏鼠标光标
    if (this.currentTool.mousemoveFn) {
      this.canvasContainerEl.classList.add('no-mouse')
    } else {
      this.canvasContainerEl.classList.remove('no-mouse')
    }
  }
  // resize 所有的 canvas
  resize() {
    clearInterval(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.frontCanvasEl.width = this.canvasContainerEl.clientWidth * this.dpr
      this.frontCanvasEl.style.width = this.canvasContainerEl.clientWidth + 'px'
      this.mainCanvasEl.style.width = this.canvasContainerEl.clientWidth + 'px'
      // canvas尺寸重置的封装函数 实现了修改 canvas大小不清空内容
      canvasResize(
        this.mainCanvasEl,
        this.mainCanvasCtx,
        this.canvasContainerEl.clientWidth * this.dpr
      )
      canvasResize(
        this.recallCanvasEl,
        this.recallCanvasCtx,
        this.canvasContainerEl.clientWidth * this.dpr
      )
    }, 200)
  }
  // 接收一个ctx渲染函数
  render(renderFn) {
    this.recallBackClean()

    if (renderFn.needRender) {
      // 对 mainCanvas进行绘制
      renderFn(this.mainCanvasCtx)
    }

    if (this.renderList.length === this.maxRecall) {
      // 达到撤回上限
      // 将 renderList中最早的绘制函数对recallCanvas进行绘制
      if (this.renderList[0]) {
        this.renderList[0](this.recallCanvasCtx)
      }
      // 删除最早的渲染函数
      this.renderList.splice(0, 1)
    }
    // 将最新的绘制函数写入数组
    this.renderList.push(renderFn)
    // 清空 frontCanvas
    this.frontCanvasCtx.clearRect(
      0,
      0,
      this.frontCanvasEl.width,
      this.frontCanvasEl.height
    )

    // 处理 recallbtn状态
    this.recallBtnStatus()
  }
  // 执行撤销
  recall() {
    if (this.renderList.length > 0) {
      const fn = this.renderList.splice(this.renderList.length - 1, 1)[0]
      this.recallBackList.unshift(fn)
      this.recallRender()
    }
  }
  // 执行撤销回退
  recallBack() {
    if (this.recallBackList.length > 0) {
      const fn = this.recallBackList.splice(0, 1)[0]
      this.renderList.push(fn)
      this.recallRender()
    }
  }
  // 清空recallback
  recallBackClean() {
    this.recallBackList = []
  }
  // recall之后执行渲染
  recallRender() {
    // 新建临时canvas防止需要的recall过多导致的页面抖动
    const tmpCanvasEl = document.createElement('canvas')
    tmpCanvasEl.width = this.mainCanvasEl.width
    tmpCanvasEl.height = this.mainCanvasEl.height

    const tmpCanvasCtx = tmpCanvasEl.getContext('2d')
    //复制 recallCanvas渲染
    tmpCanvasCtx.drawImage(this.recallCanvasEl, 0, 0)

    this.renderList.forEach(function (fn) {
      // 执行剩余的绘制函数
      fn(tmpCanvasCtx)
    })

    // 清空 main-canvas且重新绘制 main-canvas
    this.mainCanvasCtx.clearRect(
      0,
      0,
      this.mainCanvasEl.width,
      this.mainCanvasEl.height
    )
    this.mainCanvasCtx.drawImage(tmpCanvasEl, 0, 0)

    // 处理recallbtn状态
    this.recallBtnStatus()
  }
  // 处理撤销按钮显示状态
  recallBtnStatus() {
    // 判断recall按钮透明度指示
    if (this.renderList.length === 0) {
      this.containerEl.querySelector('.recall').classList.add('no-recall')
    } else {
      this.containerEl.querySelector('.recall').classList.remove('no-recall')
    }

    if (this.recallBackList.length === 0) {
      this.containerEl
        .querySelector('.recall-back')
        .classList.add('no-recall-back')
    } else {
      this.containerEl
        .querySelector('.recall-back')
        .classList.remove('no-recall-back')
    }
  }

  // 执行保存
  save(type) {
    if (type === 'btn') {
      //保存按钮触发 触发浏览器图片下载或tab页
      const saveCanvas = document.createElement('canvas')
      saveCanvas.width = this.mainCanvasEl.width
      saveCanvas.height = this.mainCanvasEl.height
      const ctx = saveCanvas.getContext('2d')
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, saveCanvas.width, saveCanvas.height)
      ctx.drawImage(this.mainCanvasEl, 0, 0)

      try {
        //ie兼容
        const blob = saveCanvas.msToBlob()
        window.navigator.msSaveBlob(blob, 'picture.png')
      } catch (error) {
        const a = document.createElement('a')
        a.href = saveCanvas.toDataURL('image/png')
        a.target = '__blank'
        a.download = 'picture.png'
        var event = document.createEvent('MouseEvents')
        event.initMouseEvent(
          'click',
          true,
          true,
          document.defaultView,
          0,
          0,
          0,
          0,
          0,
          false,
          false,
          false,
          false,
          0,
          null
        )
        a.dispatchEvent(event)
      }
    } else {
      // 返回base64
      return this.mainCanvasEl.toDataURL('image/png')
    }
  }
  // 清空画布同时清空所有撤销记录
  clean() {
    this.frontCanvasCtx.clearRect(
      0,
      0,
      this.frontCanvasEl.width,
      this.frontCanvasEl.height
    )
    this.mainCanvasCtx.clearRect(
      0,
      0,
      this.mainCanvasEl.width,
      this.mainCanvasEl.height
    )
    this.renderList = []
    this.recallBackList = []
    this.recallBtnStatus()
  }

  destroy() { }
}

export default DrawingBoard
